import installation from './installation/texts.js';

export default {
  installation,
  details: {
    generalInformation: {
      header: {
        notes: 'Header for general information accordion',
        message: 'General information',
      },
    },
    layout: {
      header: {
        notes: 'Header for layout accordion',
        message: 'Layout',
      },
    },
  },
  model: {
    updatedAt: {
      notes: 'Field updatedAt for screen deck configs',
      message: 'Last updated',
    },
    deckName: {
      notes: 'Field deckName for screen deck configs',
      message: 'Deck',
    },
    labels: {
      notes: 'Field labels for screen deck configs',
      message: 'Labels',
    },
    name: {
      notes: 'Field name for screen deck configs',
      message: 'Name',
    },
    type: {
      notes: 'Field type for screen deck configs',
      message: 'Type',
    },
    installationPeriod: {
      notes: 'Field installationPeriod for screen deck configs',
      message: 'Installation period',
    },
    installed: {
      notes: 'Field installed for screen deck configs',
      message: 'Installed',
    },
    columns: {
      notes: 'Field columns for screen deck configs',
      message: 'Columns',
    },
    rows: {
      notes: 'Field rows for screen deck configs',
      message: 'Rows',
    },
    creator: {
      notes: 'Field creator for screen deck configs',
      message: 'Creator',
    },
  },
};
